import React, { useEffect, useState } from 'react'
import { Container, Input, FormGroup, Label } from 'reactstrap'
import TableRoot from './tables/TableRoot'
import AddMachine from './AddOil'
import UpdateViewMachine from './UpdateViewOil'
import Shimmer from 'commonComponents/Shimmer'
import DeleteModel from 'commonComponents/DeleteModel'
import { useDispatch, useSelector } from 'react-redux'
import { fetchOilById, fetchOilList } from './redux/dispatcher'
import { fetchCompanyList } from 'components/companyList/redux/dispatcher'
import useDebouncedEffect from 'commonComponents/DeboucedEffect'

function Index({ }) {
    const dispatch = useDispatch();
    const oilList = useSelector((state) => state.oilListReducer);
    const [searchQuery, setSearchQuery] = useState('')
    const [isUpdate, setIsUpdate] = useState(false)
    const [isViewOnly, setIsViewOnly] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [singleOilData, setSingleOilData] = useState('')
    const [deleteItemId, setDeleteItemId] = useState('')
    const [currentPage, setCurrentPage] = useState(oilList?.data?.pagination?.currentPage || 1);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [selectedOil, setSelectedOil] = useState('ot')
    const [isLoading, setIsLoading] = useState(oilList?.isLoading)
    const [isShimmer, setIsShimmer] = useState(oilList.isLoading)
    const [totalPages, setTotalPages] = useState(oilList?.data?.pagination?.totalPages || 1);

    useEffect(() => {
        setTotalPages(oilList?.data?.pagination?.totalPages || 1)
        setCurrentPage(oilList?.data?.pagination?.currentPage || 1)
    }, [oilList?.data?.pagination?.totalPages]);

    useEffect(() => {
        setCurrentPage(oilList?.data?.pagination?.currentPage || 1)
    }, [oilList?.data?.currentPage])

    useEffect(() => {
        dispatch(fetchOilList({ searchQuery: '', selectedOil: selectedOil === 'ot' ? null : selectedOil, currentPage, rowsPerPage }))
    }, [selectedOil, currentPage]);

    useDebouncedEffect(() => {
        dispatch(fetchOilList({ searchQuery, selectedOil: selectedOil === 'ot' ? null : selectedOil, currentPage, rowsPerPage }))
    }, [searchQuery, rowsPerPage], 1000);

    useEffect(() => {
        if (oilList.selectedOil) {
            setSingleOilData(oilList?.selectedOil)
        }
    }, [oilList?.selectedOil])

    useEffect(() => {
        dispatch(fetchCompanyList())
    }, [dispatch])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearchQuery(value);
    }

    const handleEdit = (id) => {
        dispatch(fetchOilById(id, setIsUpdate))
    }

    const handleDelete = (id) => {
        setDeleteItemId(id)
        setIsDelete(true);
    }

    const handleView = (id) => {
        dispatch(fetchOilById(id, setIsViewOnly))
    }
    const handleDownload = () => {


    };

    if (isLoading) {
        return (
            <>
                <Shimmer />
            </>
        )
    }

    const tableData = oilList?.data?.oilDataWithSerialNumber || []

    return (
        <>
            {/* <div className=""> */}
            <div className="col-12 d-flex justify-content-end stickyFilter" >
                <Container fluid>
                    <div className="d-flex flex-row justify-content-end mt-4 mb-3">
                        <FormGroup className="mr-3">
                            <Label for="oiltype" hidden>Select Company*</Label>
                            <Input
                                type="select"
                                name="oiltype"
                                id="oiltype"
                                value={selectedOil}
                                onChange={(e) => {
                                    setSelectedOil(e.target.value)
                                    setCurrentPage(1)
                                }}
                                style={{ width: '240px' }}
                            >
                                {selectedOil === "ot" && (
                                    <option value="ot" disabled hidden>Select Oil Type</option>
                                )}
                                <option value="">All</option>
                                <option value="coolant">Coolant Oil</option>
                                {/* <option value="maintenance">Maintenance Oil</option> */}
                                <option value="maintenance">Neat Oil</option>
                                <option value="hydraulic">Hydraulic Oil</option>


                            </Input>
                        </FormGroup>
                        <FormGroup className="mr-3">
                            <Label for="searchInput" hidden>Search</Label>
                            <div style={{ position: 'relative', width: "230px", display: 'inline-block' }}>
                                <Input
                                    type="text"
                                    id="searchInput"
                                    value={searchQuery}
                                    onChange={(e) => {
                                        handleSearchChange(e)
                                        setCurrentPage(1)
                                    }}
                                    placeholder="Search by Brand Name"
                                    style={{ width: "100%", paddingRight: "30px" }}
                                />
                                {searchQuery && (
                                  <i
                                    className="fa-solid fa-xmark"
                                    style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d' }}
                                    onClick={() => {
                                      setSearchQuery("");
                                      setCurrentPage(1);
                                    }}
                                  ></i>
                                )}
                            </div>
                        </FormGroup>

                        <div>
                            {
                                isUpdate || isViewOnly ?
                                    <UpdateViewMachine
                                        isViewOnly={isViewOnly}
                                        setIsUpdate={setIsUpdate}
                                        setIsViewOnly={setIsViewOnly}
                                        data={singleOilData}
                                        searchQuery={searchQuery}
                                        selectedOil={selectedOil}
                                    />
                                    : <AddMachine />
                            }
                            {
                                isDelete ? <DeleteModel setIsDelete={setIsDelete} /> : ''
                            }
                        </div>

                    </div>
                </Container>
            </div>
            {/* </div> */}


            <div>
                {
                    isShimmer ? <Shimmer /> :

                        <TableRoot
                            header={['Sr. No.', 'Brand Name', 'Product Name', 'Company Name',
                                'Price', 'Type', 'Status', 'Action',]}
                            tableData={tableData}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                            handleView={handleView}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            handlePageChange={handlePageChange}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                            selectedOil={selectedOil}
                        />
                }
            </div>
        </>
    )
}

export default Index
